module.exports = __webpack_public_path__ + "static/media/moe.2cf5144e.png";